import React, { VFC } from 'react';

import TabNav from './TabNav';
import DropdownNav from './DropdownNav';

const NavBar: VFC = () => {
  return (
    <header className="navbar wow fadeInDown">
      <TabNav />
      <DropdownNav />
    </header>
  );
};

export default NavBar;
